
export class SubscriptionPucharseEntity {
  corpId: number;
  id: number;
  subscriptionId: number;
  pucharseType: string;
  pucharseId: number;
  pucharseName: string;
  pucharseReference: string;
  pucharseStartDate: string;
  pucharseEndDate: string;
  pucharsePrice: number;
  paymentId: number;
}
